import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";

export function getRepresentatives(searchTerm) {
    const url = `${urls.REPRESENTATIVES_URL}${searchTerm}`;
    const request = axios.get(url);
    return { type: ActionTypes.GET_REPRESENTATIVES, payload: request };
}
